<dx-lookup
    [value]="$pageSize()"
    (valueChange)="$pageSize.set($event)"
    [dataSource]="$allowedPageSizes()"
    [width]="80"
/>

<div class="d-flex align-items-center ms-1">
    <span class="px-2 fw-light text-secondary">{{$totalRows()}} records</span>

    <dx-button stylingMode="text" icon="chevronprev" [disabled]="$currentPage() <= 1" (onClick)="prevPage()" />

    <dx-number-box
        [value]="$currentPage()"
        (valueChange)="$currentPage.set($event)"
        [width]="70"
        [min]="1"
        [max]="$pageCount()"
        [step]="1" />

    <span class="text-secondary mx-1">{{'COMMON.LABEL_OF' | translate}}</span>

    <span>{{$pageCount()}}</span>

    <dx-button stylingMode="text" icon="chevronnext" [disabled]="$currentPage() >= $pageCount()" (onClick)="nextPage()" />
</div>
